import React from "react";
import { NotificationBanner, NotificationBannerBody, NotificationBannerHeader } from "@ceridianhcm/components";

type BannerProps = {
  infoStatus?: string;
  infoDescription?: string;
  warningStatus?: string;
  warningDescription?: string;
  errorStatus?: string;
  errorDescription?: string;
};

const Banner: React.FC<BannerProps>=({
infoStatus,
infoDescription,
warningStatus,
warningDescription,
errorStatus,
 errorDescription
}) => {
  return (
    <div >
      {infoStatus && <NotificationBanner id="info-status-id" status="info" onCloseButtonClick={() => {}} textMap={{ ariaLabel: 'Info Status Banner', closeButtonAriaLabel: 'Close' }} testId="info-status-test-id">
        <NotificationBannerHeader id="info-status-header-id">
          <h4 className="evrHeading4">{infoStatus}</h4>
        </NotificationBannerHeader>
        <NotificationBannerBody id="info-status-body-id">
          <p className="evrBodyText1">{infoDescription}</p>
        </NotificationBannerBody>
      </NotificationBanner>}
      {warningStatus && <NotificationBanner id="warning-status-id" status="warning" onCloseButtonClick={() => {}} textMap={{ ariaLabel: 'Warning Status Banner', closeButtonAriaLabel: 'Close' }} testId="warning-status-test-id">
        <NotificationBannerHeader id="warning-status-header-id">
          <h4 className="evrHeading4">{warningStatus}</h4>
        </NotificationBannerHeader>
        <NotificationBannerBody id="warning-status-body-id">
          <p className="evrBodyText1">{warningDescription}</p>
        </NotificationBannerBody>
      </NotificationBanner>}
      {errorStatus && <NotificationBanner id="error-status-id" status="error" textMap={{ ariaLabel: 'Error Status Banner' }} testId="error-status-test-id">
        <NotificationBannerHeader id="error-status-header-id">
          <h4 className="evrHeading4">{errorStatus}</h4>
        </NotificationBannerHeader>
        <NotificationBannerBody id="error-status-body-id">
          <p className="evrBodyText1">{errorDescription}</p>
        </NotificationBannerBody>
      </NotificationBanner>}
    </div>
   )
}

export default Banner;